import { Descendant } from 'slate'

import { BLOCK_FORMATS } from 'core-components/library/richTextEditor/interface/custom-types'

export const DEFAULT_EDITOR_VALUE: Descendant[] = [
  {
    type: BLOCK_FORMATS.paragraph,
    children: [{ text: '' }],
  },
]
const DEFAULT_POINT = { path: [0, 0], offset: 0 }
export const DEFAULT_SELECTION_VALUE = { anchor: DEFAULT_POINT, focus: DEFAULT_POINT }
